define(function(require, exports, module) {
    'use strict';

    module.exports = {
        NETWORK_ERROR: -1,
        PARSE_ERROR: -2,
        ABORT_ERROR: -3
    };
});
